import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../_services/toast-service';
import { ResponsiveService } from '../_services/responsive.service';
import { TestService } from '../_services/test.service';
import { StudentService } from '../_services/student.service';
import { OrgService } from '../_services/org.service';
import { Student } from '../student-list/student';
import { Subscription } from 'rxjs/internal/Subscription';
import { Classroom } from '../dropdown-classroom/org.classroom';
import { PhaseService } from '../_services/phase.service';

@Component({
	selector: 'app-phonics-adv',
	templateUrl: './phonics-adv.component.html',
	styleUrls: ['./phonics-adv.component.css'],
})
export class PhonicsAdvComponent implements OnInit {
	testQuestions;
	testQuestionsTotal;
	previousScores; //Will become a copy of scores from data.testQuestions into an array-of-scores[question id]
	previousScoresMatchScoredTQs; //Used to bind the "No Change" checkbox state to whether the selected score to-be-submitted matches the old score.
	previousYear = false;
	page = 1;
	blankDate = { year: 'yyyy', month: 'mm', day: 'dd' };
	testDate = this.blankDate;
	scoredTQs = {};
	student: Student;
	activeClassroom: any;
	startDate: any;
	endDate: any;
	isValidDate: boolean = false;
	subscriptions: Subscription[] = [];
	assessmentBookId: number;
	selectedPhase: any;
	constructor(
		public activeModal: NgbActiveModal,
		private calendar: NgbCalendar,
		public toastService: ToastService,
		public rsp: ResponsiveService,
		private testService: TestService,
		private studentService: StudentService,
		private orgService: OrgService,
		private phaseService: PhaseService
	) {
		this.student = this.studentService.getSelectedStudentAsObj();

		this.subscriptions.push(
			this.testService
				.getPhonicsTestQuestions(this.student.id, this.student.assessmentBookId, this.student.assessmentTemplateId)
				.subscribe(
					(data) => {
						console.log('Placing data in testQuestions object');
						this.testQuestions = data.testQuestions;
						this.previousScores = this.copyScores(data.testQuestions); //Copying scores before user edits them for Zero Progress functionality
						this.previousYear = data.previousYear;
						this.previousScoresMatchScoredTQs = [Object.keys(data.testQuestions).length]; //Initializing boolean array.
						this.testQuestionsTotal = data.testQuestionsTotal;

						this.previousScoresMatchScoredTQs.fill(false);
						this.selectedPhase = data.phases.filter((obj) => {
							return obj.assessmentBookId == this.student.assessmentBookId;
						});

						this.page = data.lastScoredTestPage;
					},
					(error) => {
						console.log(error);
					}
				)
		);

		this.testService.getPhonicsStartEndDates(this.orgService.selectedClassroom.id).subscribe(
			(data) => {
				this.startDate = {
					year: data.start.year,
					month: data.start.month,
					day: data.start.day,
				};
				let curDate = new Date();
				let currentDate = {
					year: curDate.getFullYear(),
					month: curDate.getMonth() + 1, // getMonth() returns 0-11, we need 1-12
					day: curDate.getDate(),
				};

				// Get API end date
				let apiEndDate = {
					year: data.end.year,
					month: data.end.month,
					day: data.end.day,
				};

				let currentDateObj = new Date(currentDate.year, currentDate.month - 1, currentDate.day);
				let apiEndDateObj = new Date(apiEndDate.year, apiEndDate.month - 1, apiEndDate.day);

				// Use whichever date comes first (earlier)
				this.endDate = currentDateObj <= apiEndDateObj ? currentDate : apiEndDate;
			},
			(error) => {
				console.log(error);
			}
		);

		this.activeClassroom = this.orgService.getClassroomAsObj();
	}
	ngOnInit(): void {}

	handleChangeRadio(eachQuestionObject) {
		this.scoredTQs[eachQuestionObject.id] = eachQuestionObject;
		console.log('Scored selected: ');
		console.log(this.scoredTQs);
		//Next line aligns ngModel checkbox state with the fact that the scored TQ matches its previous score ("No Change" checkbox)
		this.previousScoresMatchScoredTQs[eachQuestionObject.id] =
			this.scoredTQs[eachQuestionObject.id].latestScore == this.previousScores[eachQuestionObject.id];
		console.log('scoredTQ');
		console.log('Checkbox boolean array: ');
		console.log(this.previousScoresMatchScoredTQs);
	}
	handleZeroProgress(eachQuestionObject, event) {
		console.log(eachQuestionObject);
		//console.log(this.testQuestions);
		if (event.target.checked) {
			if (!this.previousScores[eachQuestionObject.id]) {
				//If the previous scores didn't contain this question, do not allow a Zero progress entry
				console.log('Latest score was zero. LatestScore: ' + eachQuestionObject.latestScore + '.');
				event.target.checked = false;
				return; //Unchecks checkbox and does not change data to be sent.
			}
			console.log('saved previous score: ' + this.previousScores[eachQuestionObject.id]);
			console.log('LatestScore: ' + eachQuestionObject.latestScore);
			eachQuestionObject.latestScore = this.previousScores[eachQuestionObject.id]; //Ensures UI highlight matches real previous scores, even if user changed it before.
			this.scoredTQs[eachQuestionObject.id] = eachQuestionObject; //If valid zero progress, add highlighted score to submission "scoredTQs"
		} else {
			//If checkbox is being un-checked
			this.previousScoresMatchScoredTQs[eachQuestionObject.id] = false; // since this question is not being submitted, it cannot match the previous score.
			delete this.scoredTQs[eachQuestionObject.id]; //remove this question from return object
			console.log('Question removed by id: ' + eachQuestionObject.id);
		}

		console.log('Zero Progress handled');
		console.log('Checkbox state: ' + event.target.checked); //gives new checkbox state after click
		console.log(this.scoredTQs);
		console.log('End of Zero Progress handle');
	} //Braindstorming, not current solution

	copyScores(testquestions) {
		let idScoreArray = [];
		for (const page of testquestions) {
			for (const question of page) {
				if (question.latestScore != 0) {
					idScoreArray[question.id] = question.latestScore;
				}
			}
		}
		console.log(idScoreArray);
		return idScoreArray;
	}

	submitScores() {
		console.log('Submit Scores called.');
		let submitObject = {};
		submitObject['studentId'] = this.student.id;
		submitObject['scores'] = this.scoredTQs;
		submitObject['testDate'] = this.testDate;
		submitObject['assessmentBookId'] = this.student.assessmentBookId;
		submitObject['assessmentTemplateId'] = this.student.assessmentTemplateId;

		if (!this.isValidDate) {
			this.toastService.showError('Please select test date');
			return;
		}

		this.testService.submitPhonicsScore(submitObject).subscribe(
			(data) => {
				this.subscriptions.push(
					this.phaseService.studentPhase$(this.student.id).subscribe((phases) => {
						this.toastService.showSuccess(data.message);
						this.studentService.setStudent(this.student);
						let phase = phases.find(({ status }) => status === 'Current');

						if (typeof phase !== 'undefined') {
							const isFound = this.student.phases.some((element) => {
								if (element.assessmentTemplateId === phase.assessmentTemplateId) {
									return true;
								}
								return false;
							});

							if (!isFound) {
								this.student.phases.push({
									title: phase.title,
									assessmentTemplateId: phase.assessmentTemplateId,
									assessmentBookId: phase.assessmentBookId,
									status: phase.status,
								});
							}
						}
					})
				);

				this.studentService.setStudent(this.student);
				this.activeModal.close();
			},
			(error) => {
				this.toastService.showError(error);
			}
		);
	}

	dateChangeEvent() {
		if (!isNaN(Date.parse(this.testDate.year))) {
			this.isValidDate = true;
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	findChallengeNumber(testQuestions, pageNumber: number, currentIndex: number) {
		let count = 0;
		for (var p = 0; p < pageNumber - 1; p++) {
			count += testQuestions[p].length; //Add up the number of questions from previous pages.
		}
		return count + currentIndex + 1; //Add previous page questions to current page's question selected, plus one, to get display number.
		//currentIndex should be the index of the question on page number "pageNumber". We must add one to get the displayed number.
	}

	sliceLabel(label: string) {
		var index = 0;
		for (let char of label) {
			index++;
			if (char == '.') {
				return [label.slice(0, index), label.slice(index)];
			} //Find period . to slice number from label (ex: "12." and " Reading comprehension"). Return tuple of strings.
		}
		return [label, ''];
	}
}
